import createDataContext from './createDataContext';
import * as actions from './actions/upcomingServiceActions';
import { reducer, initialState } from './reducers/upcomingServiceReducer';

export const { Context: UpcomingServiceContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
